<template>
	<div class="http-in-progress-component">
		<div class="http-in-progress-spinner">
			
		</div>
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss">
	@import '../styles/app';
	@import '../styles/components/httpInProgress';
</style>